import { api } from './index';

const BASE_PATH = '/api/internal/service_companies';

export type ServiceCompany = {
  id: number;
  taxName: string;
  dni: string;
  serviceType: string;
  receiptsEmail?: string;
  displayName: string;
  humanCreatedAt?: string;
  humanDiscardedAt?: string;
};

export type ServiceCompanyForm = {
  taxName: string;
  dni: string;
  serviceType: string;
  receiptsEmail?: string;
};

export const serviceCompaniesApi = {
  index(scope: 'active' | 'discarded' = 'active'): Promise<Array<ServiceCompany>> {
    return api({
      method: 'get',
      url: `${BASE_PATH}?scope=${scope}`,
    }).then(response => response.data.serviceCompanies);
  },

  create(serviceCompany: ServiceCompanyForm): Promise<ServiceCompany> {
    return api({
      method: 'post',
      url: BASE_PATH,
      data: { serviceCompany },
    }).then(response => response.data.serviceCompany);
  },

  update(serviceCompany: Partial<ServiceCompanyForm> & { id: number }): Promise<ServiceCompany> {
    return api({
      method: 'put',
      url: `${BASE_PATH}/${serviceCompany.id}`,
      data: { serviceCompany },
    }).then(response => response.data.serviceCompany);
  },

  destroy(id: number): Promise<void> {
    return api({
      method: 'delete',
      url: `${BASE_PATH}/${id}`,
    }).then(() => {});
  },
};
